module.exports = __webpack_public_path__ + "static/Chirpyest_Member_page_icon@2x-ec3eb00a7cd62d47be67a890198f79df.png";